import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const categories = require('./assets/categories.json')
const data = require('./assets/data.json')

export default new Vuex.Store({
  state: {
    categories, data
  },
  mutations: {

  },
  actions: {

  },
  getters: {
    slug: (state) => (data: string) => {
      return data.toLowerCase().replace(/ /g, '-')
    }
  }
})



// WEBPACK FOOTER //
// ./src/store.ts